import React from 'react';
import Hero from '../components/Hero/Hero';
import BadgeSection from '../components/Badges/BadgeSection';
import RequestQuote from '../components/CTA/RequestQuote';
import AboutSection from '../components/About/AboutSection';
import WideCtaSection from '../components/CTA/WideCtaSection';
import YellowCta from '../components/CTA/YellowCta';
import ServicesSection from '../components/Services/ServicesSection';
import HowItWorksSection from '../components/HowItWorks/HowItWorksSection';
import AboutUs from '../components/About/AboutUs';

function City({ cityData, locationInfo }) {
  return (
    <>
      <Hero
        cityData={cityData}
        locationInfo={locationInfo}
      />
      <YellowCta
        cityData={cityData}
        locationInfo={locationInfo}
      />
      <ServicesSection
          cityData={cityData}
          locationInfo={locationInfo}
      />
      <WideCtaSection
        cityData={cityData}
        locationInfo={locationInfo}
      />
      <HowItWorksSection
        cityData={cityData}
        locationInfo={locationInfo}
      />
      <AboutUs 
        cityData={cityData}
        locationInfo={locationInfo}
      />
      <AboutSection />
      <RequestQuote 
        cityData={cityData}
        locationInfo={locationInfo}
      />
      <BadgeSection
        cityData={cityData}
        locationInfo={locationInfo}
      />
    </>
  );
}

export default City;